import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchWhRegistrationResults } from 'src/app/core/models/transport-operation/search-whRegistration-results';
import { AddWarehousingRegistrationRequest } from 'src/app/core/models/transport-operation/warehousing-registration';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehousingRegistrationService {

  constructor(
    private http: HttpClient
  ) { }

  searchWarehousingRegistration(params: any):Observable<SearchWhRegistrationResults[]>{
    const url = `${environment.logisticsApiUrl}/warehousing/search/warehousingRegistration`;
    return this.http.post<SearchWhRegistrationResults[]>(url, params);
  }

  addWarehousingRegistration(params: AddWarehousingRegistrationRequest):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/add/warehousingRegistration`;
    return this.http.post(url, params);
  }

  comfirmArrivedWarehousing(params: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/comfirmArrived`;
    return this.http.post(url, params);
  }

  importRegistrationExcel(file:any):Observable<any>{

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const url = `${environment.logisticsApiUrl}/Warehousing/registration/import`;
    return this.http.post(url,formData);
  }

  saveRegistration(data:any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/Warehousing/saveRegistrationByImport`;
    return this.http.post(url,data);
  }

  exportExcel(param: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Warehousing/registration/export`;
    return this.http.post(url, param, { responseType: 'blob'});
  }

  updateRegistration(request : any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/Warehousing/registration/update`;
    return this.http.post(url,request);
  }

  getAbnormalOptions(cmsCode:string):Observable<any>{
    const url = `${environment.logisticsApiUrl}/appCsmSetting/getAppCsmSettingByCsmCode/${cmsCode}`;
    return this.http.get(url);
  }

  downloadTemplate(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Warehousing/registration/downloadTemplate`;
    return this.http.get(url, { responseType: 'blob' });
  }

}
